<script setup lang="ts">
import { onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest, msalInstance } from "@/msalAuthConfig";
import { useApiStore } from "@/stores/api";
import { waitForOffice } from "@/utils/office";
import SideLoadMessage from "@/components/SideLoadMessage.vue";
import InfoCard from "@/components/task-pane/InfoCard.vue";
import ApiComboBox from "@/components/task-pane/ApiComboBox.vue";
import FunctionComboBox from "@/components/task-pane/FunctionComboBox.vue";
import { ensureAuthenticated } from "@haskoning/msal";

const apiStore = useApiStore();
const { rawUrls, autoGenerateForm } = storeToRefs(apiStore);

const showSideloadMessage = ref(true);
const isAuth = ref(false);

onMounted(async () => {
  const officeAvailable = await waitForOffice();

  if (officeAvailable) {
    // Initialize Office JS
    await Office.onReady(async (info: any) => {
      if (info.host === Office.HostType.Excel) {
        showSideloadMessage.value = false;
        isAuth.value = await ensureAuthenticated(msalInstance, InteractionType.Popup, loginRequest);

        if (isAuth.value) {
          await apiStore.loadInventory();
          await apiStore.syncUrls(rawUrls.value);
        }
      }
    });
  } else {
    console.warn("Office.js failed to load after retries");
  }
});
</script>

<template>
  <SideLoadMessage v-if="showSideloadMessage" />

  <template v-else>
    <div v-if="!isAuth" class="d-flex justify-center align-center fill-height">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>

    <div v-else>
      <ApiComboBox />
      <FunctionComboBox v-if="autoGenerateForm" />
      <InfoCard />
    </div>
  </template>
</template>

<style scoped></style>
